/* ============================================================
   TAKA — Custom Theme JavaScript — v2
   ============================================================ */

/* ─── Sticky header: esconder al bajar, mostrar al subir ─────── */
(function () {
  const header = document.querySelector('.site-header');
  const spacer = document.getElementById('header-spacer');
  if (!header) return;

  /* Sincronizar --header-h en resize (sin valores quemados en el HTML) */
  if (spacer) {
    const isMobile = () => window.innerWidth <= 768;
    const syncSpacer = () => {
      const h = isMobile()
        ? parseInt(header.dataset.heightMobile, 10)
        : parseInt(header.dataset.height, 10);
      if (h) document.documentElement.style.setProperty('--header-h', h + 'px');
    };
    window.addEventListener('resize', syncSpacer);
    syncSpacer(); // sincronizar al cargar también
  }

  /* Esconder al bajar / mostrar al subir */
  if (header.dataset.sticky !== 'true') return;

  let lastY    = window.scrollY;
  let ticking  = false;
  const THRESHOLD = 80; // px desde el top donde empieza a esconderse

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const currentY = window.scrollY;
      if (currentY <= THRESHOLD) {
        // Cerca del top: siempre mostrar
        header.classList.remove('header--hidden');
      } else if (currentY > lastY) {
        // Bajando: esconder
        header.classList.add('header--hidden');
      } else {
        // Subiendo: mostrar
        header.classList.remove('header--hidden');
      }
      lastY   = currentY;
      ticking = false;
    });
  }, { passive: true });
})();

document.addEventListener('DOMContentLoaded', () => {

  /* ----- Mover nav-drawer y overlay al body ────────────────────
     Garantiza que position:fixed funcione aunque el section wrapper
     tenga algún transform/will-change en el editor de Shopify.
  ─────────────────────────────────────────────────────────────── */
  const navDrawer  = document.querySelector('.nav-drawer');
  const navOverlay = document.querySelector('.nav-overlay');
  if (navDrawer  && navDrawer.parentElement  !== document.body) document.body.appendChild(navDrawer);
  if (navOverlay && navOverlay.parentElement !== document.body) document.body.appendChild(navOverlay);

  /* ----- Mobile nav drawer ------------------------------------- */
  const navToggle  = document.querySelector('.nav-toggle');
  const navClose   = document.querySelector('.nav-drawer .close-btn');

  function openNav() {
    navDrawer?.classList.add('open');
    navOverlay?.classList.add('show');
    document.documentElement.classList.add('nav-open');
  }
  function closeNav() {
    navDrawer?.classList.remove('open');
    navOverlay?.classList.remove('show');
    document.documentElement.classList.remove('nav-open');
  }
  navToggle?.addEventListener('click', openNav);
  navClose?.addEventListener('click', closeNav);
  navOverlay?.addEventListener('click', closeNav);

  /* ----- Product tabs ------------------------------------------ */
  document.querySelectorAll('.product-tabs__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.product-tabs__btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tabs__panel').forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      document.querySelector(`.product-tabs__panel[data-tab="${target}"]`)?.classList.add('active');
    });
  });

  /* ----- Quantity selector ------------------------------------- */
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('input');
    selector.querySelector('.qty-minus')?.addEventListener('click', () => {
      if (parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
    selector.querySelector('.qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1;
    });
  });

  /* ----- Product gallery thumbnails ---------------------------- */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const img  = thumb.querySelector('img');
      const main = document.querySelector('.product-gallery__main img');
      if (main && img) {
        const hiRes = thumb.dataset.src || img.src;
        main.src    = hiRes;
        main.srcset = '';
        main.alt    = img.alt;
      }
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ─── CART DRAWER ─────────────────────────────────────────── */
  const cartDrawer  = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartDrawerOverlay');
  const cartClose   = document.getElementById('CartDrawerClose');
  const cartBody    = document.getElementById('CartDrawerBody');
  const cartFooter  = document.getElementById('CartDrawerFooter');
  const cartSubtotal = document.getElementById('CartDrawerSubtotal');

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function escapeHTML(value) {
    return String(value ?? '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
  }

  function safeCartImageUrl(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      if (!['http:', 'https:'].includes(parsed.protocol)) return '';
      return parsed.href.replace(/(\.\w+)(\?.*)?$/, '_120x120$1$2');
    } catch (error) {
      return '';
    }
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartOverlay?.addEventListener('click', closeCartDrawer);
  cartClose?.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCartDrawer(); });

  function updateCartBadge(count) {
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ----- Progreso envío gratis (descuentos automáticos: 3+ productos o desde $75.000) ----- */
  const shipBox   = document.getElementById('CartShippingProgress');
  const shipMsg   = document.getElementById('CartShippingMsg');
  const shipBar   = document.getElementById('CartShippingBar');
  const shipFill  = document.getElementById('CartShippingFill');

  function updateShippingProgress(cart) {
    if (!shipBox) return;
    const minQty   = parseInt(shipBox.dataset.minQty, 10) || 3;
    const minTotal = parseInt(shipBox.dataset.minTotal, 10) || 7500000; // centavos
    const count = cart.item_count || 0;
    const total = cart.total_price || 0; // ya incluye descuentos de combos

    if (count === 0) { shipBox.hidden = true; return; }
    shipBox.hidden = false;

    const missingQty   = Math.max(0, minQty - count);
    const missingTotal = Math.max(0, minTotal - total);
    const done = missingQty === 0 || missingTotal === 0;
    shipBox.classList.toggle('is-complete', done);

    if (done) {
      shipMsg.innerHTML = '¡Bravo! 🎉 Tu envío es <strong>GRATIS</strong>';
    } else {
      const qtyLabel = missingQty === 1 ? '1 producto' : `${missingQty} productos`;
      shipMsg.innerHTML = `Te faltan <strong>${formatMoney(missingTotal)}</strong> o <strong>${qtyLabel}</strong> para tener envío <strong>GRATIS</strong>`;
    }

    const progress = Math.min(1, Math.max(count / minQty, total / minTotal));
    shipFill.style.width = `${progress * 100}%`;
    shipBar.setAttribute('aria-valuenow', Math.round(progress * 100));
  }

  /* ----- Sugerencia en el carrito ----------------------------- */
  const upsellBox = document.getElementById('CartUpsell');
  let upsellToken = 0;

  async function pickUpsell(cart) {
    const inCart = new Set(cart.items.map(i => i.handle));
    const pairs = JSON.parse(upsellBox.dataset.pairs || '{}');
    for (const item of cart.items) {
      const mate = pairs[item.handle];
      if (mate && !inCart.has(mate)) {
        const p = await fetch(`/products/${mate}.js`).then(r => r.ok ? r.json() : null);
        if (p && p.available) return { product: p, note: upsellBox.dataset.pairNote };
      }
    }
    const recs = await fetch(`${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=6`)
      .then(r => r.ok ? r.json() : { products: [] });
    const p = (recs.products || []).find(r => r.available && !inCart.has(r.handle));
    return p ? { product: p, note: '' } : null;
  }

  async function renderUpsell(cart) {
    if (!upsellBox) return;
    const token = ++upsellToken;
    if (!cart.item_count) { upsellBox.hidden = true; return; }
    let pick = null;
    try { pick = await pickUpsell(cart); } catch (e) { pick = null; }
    if (token !== upsellToken) return; /* llegó un carrito más nuevo */
    if (!pick) { upsellBox.hidden = true; return; }

    const p = pick.product;
    const variant = p.variants.find(v => v.available) || p.variants[0];
    const minTotal = parseInt(shipBox?.dataset.minTotal, 10) || 7500000;
    const note = pick.note || (cart.total_price < minTotal
      ? `Agrégalo y te acercas al envío gratis`
      : 'Complementa tu pedido');
    const img = escapeHTML(safeCartImageUrl(p.featured_image));
    upsellBox.innerHTML = `
      <p class="cart-drawer__upsell-label">Te recomendamos</p>
      <div class="cart-drawer__upsell-card">
        <img src="${img}" alt="" width="64" height="64" loading="lazy">
        <div class="cart-drawer__upsell-info">
          <a href="${escapeHTML(p.url)}" class="cart-drawer__upsell-title">${escapeHTML(p.title)}</a>
          <span class="cart-drawer__upsell-price">${formatMoney(variant.price)}${p.variants.length > 1 && variant.title !== 'Default Title' ? ` · ${escapeHTML(variant.title)}` : ''}</span>
          <span class="cart-drawer__upsell-note">${escapeHTML(note)}</span>
        </div>
        <button type="button" class="cart-drawer__upsell-add" data-variant="${escapeHTML(variant.id)}">Agregar</button>
      </div>`;
    upsellBox.hidden = false;
    upsellBox.querySelector('.cart-drawer__upsell-add').addEventListener('click', async e => {
      const btn = e.currentTarget;
      btn.disabled = true; btn.textContent = 'Agregando…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(btn.dataset.variant, 10), quantity: 1 })
        });
        refreshDrawer();
      } catch (err) {
        console.error('Upsell add error:', err);
        btn.disabled = false; btn.textContent = 'Agregar';
      }
    });
  }

  function renderCartItems(cart) {
    updateShippingProgress(cart);
    renderUpsell(cart);
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="cart-drawer__empty">Tu carrito está vacío</div>';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    const titleSize    = cartBody.dataset.itemTitleSize    || '13';
    const titleColor   = cartBody.dataset.itemTitleColor   || '#111111';
    const priceSize    = cartBody.dataset.itemPriceSize    || '15';
    const priceColor   = cartBody.dataset.itemPriceColor   || '#111111';
    const variantColor = cartBody.dataset.itemVariantColor || '#888888';

    cartBody.innerHTML = cart.items.map(item => {
      const itemKey = escapeHTML(item.key);
      const itemTitle = escapeHTML(item.product_title);
      const itemVariant = escapeHTML(item.variant_title);
      const itemImage = escapeHTML(safeCartImageUrl(item.image));

      return `
      <div class="cart-drawer__item" data-key="${itemKey}">
        <img class="cart-drawer__item-img"
          src="${itemImage}"
          alt="${itemTitle}" loading="lazy" width="120" height="120">
        <div>
          <div class="cart-drawer__item-title" style="font-size:${titleSize}px; color:${titleColor};">${itemTitle}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="cart-drawer__item-variant" style="color:${variantColor};">${itemVariant}</div>` : ''}
          <div class="cart-drawer__item-price" style="font-size:${priceSize}px; color:${priceColor};">${formatMoney(item.final_line_price)}</div>
          <div class="cart-drawer__item-controls">
            <div class="cart-drawer__item-qty">
              <button type="button" class="drawer-qty-minus" data-key="${itemKey}" aria-label="Restar">−</button>
              <span>${escapeHTML(item.quantity)}</span>
              <button type="button" class="drawer-qty-plus"  data-key="${itemKey}" aria-label="Sumar">+</button>
            </div>
            <button type="button" class="cart-drawer__item-remove" data-key="${itemKey}" aria-label="Eliminar">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="18" height="18">
                <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
    }).join('');

    if (cartFooter) cartFooter.style.display = 'block';
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    /* Quantity + / − */
    cartBody.querySelectorAll('.drawer-qty-minus, .drawer-qty-plus').forEach(btn => {
      btn.addEventListener('click', () => {
        const key   = btn.dataset.key;
        const delta = btn.classList.contains('drawer-qty-plus') ? 1 : -1;
        const item  = cart.items.find(i => i.key === key);
        if (!item) return;
        changeCartItem(key, Math.max(0, item.quantity + delta));
      });
    });

    /* Remove */
    cartBody.querySelectorAll('.cart-drawer__item-remove').forEach(btn => {
      btn.addEventListener('click', () => changeCartItem(btn.dataset.key, 0));
    });
  }

  function changeCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      renderCartItems(cart);
      updateCartBadge(cart.item_count);
    })
    .catch(console.error);
  }

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function refreshDrawer() {
    if (cartBody) cartBody.innerHTML = '<div class="cart-drawer__loading">Cargando...</div>';
    fetchCart().then(cart => {
      renderCartItems(cart);
      updateCartBadge(cart.item_count);
    });
  }

  /* ----- Add to cart ------------------------------------------ */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = document.getElementById('SelectedVariantId')?.value
        || btn.dataset.variantId;
      const qtyInput  = document.querySelector('.qty-selector input');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!variantId) return;

      const origText = btn.dataset.btnText || btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = 'Añadiendo...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
        });
        refreshDrawer();
        openCartDrawer();
      } catch (err) {
        console.error('Cart add error:', err);
        alert('Error al añadir al carrito. Intenta de nuevo.');
      } finally {
        btn.disabled = false;
        btn.textContent = origText;
      }
    });
  });

  /* ----- Buy now ---------------------------------------------- */
  document.querySelectorAll('[data-buy-now]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = document.getElementById('SelectedVariantId')?.value
        || btn.dataset.variantId;
      const qtyInput  = document.querySelector('.qty-selector input');
      const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Procesando...';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
        });
        window.location.href = '/checkout';
      } catch (err) {
        console.error('Buy now error:', err);
        btn.disabled = false;
        btn.textContent = 'COMPRAR AHORA';
      }
    });
  });

  /* ----- Cart icon → abrir drawer ----------------------------- */
  document.querySelectorAll('[data-cart-trigger]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      refreshDrawer();
      openCartDrawer();
    });
  });

  /* Cargar badge al iniciar */
  fetchCart().then(cart => updateCartBadge(cart.item_count)).catch(() => {});

  /* ----- View toggle (grid/list) ------------------------------ */
  document.querySelectorAll('.view-toggle button').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.view-toggle button').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ----- Filter sidebar (mobile toggle) ----------------------- */
  const filterToggle = document.querySelector('.filter-toggle');
  const sidebar = document.querySelector('.collection-sidebar');
  filterToggle?.addEventListener('click', () => {
    sidebar?.classList.toggle('open');
  });

  /* ----- Hero carousel dots ----------------------------------- */
  const dots = document.querySelectorAll('.hero-dots span');
  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      dots.forEach(d => d.classList.remove('active'));
      dot.classList.add('active');
    });
  });

});

/* ─── GSAP — Animaciones de entrada en scroll ─────────────────────
   Se activan cuando cada elemento entra en el viewport.
   NO se ejecutan dentro del editor de Shopify.
──────────────────────────────────────────────────────────────────── */
window.addEventListener('load', () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  /* No animar dentro del editor: los elementos deben verse siempre */
  if (window.Shopify && window.Shopify.designMode) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  gsap.registerPlugin(ScrollTrigger);

  /* ─── Helpers ──────────────────────────────────────────────────── */

  /* Sube desde abajo */
  /* Helper: ¿el elemento ya es visible en el viewport al cargar? */
  const isInView = el => {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  };

  const baseScrollTrigger = trigger => ({
    trigger,
    start: 'top 92%',
    once: true
  });

  const clearMotionProps = target => {
    gsap.set(target, { clearProps: 'opacity,visibility,transform' });
  };

  const fadeUp = (selector, extra = {}) => {
    const { y: fromY = 22, ...restExtra } = extra;
    document.querySelectorAll(selector).forEach(el => {
      if (isInView(el)) return; /* ya visible → no ocultar */
      gsap.fromTo(el,
        { autoAlpha: 0, y: fromY },
        { autoAlpha: 1, y: 0, duration: 0.48, ease: 'power2.out',
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(el),
          onComplete() { clearMotionProps(el); },
          ...restExtra }
      );
    });
  };

  /* Entra desde la izquierda */
  const fadeLeft = (selector, extra = {}) => {
    const { x: fromX = -24, ...restExtra } = extra;
    document.querySelectorAll(selector).forEach(el => {
      if (isInView(el)) return;
      gsap.fromTo(el,
        { autoAlpha: 0, x: fromX },
        { autoAlpha: 1, x: 0, duration: 0.5, ease: 'power2.out',
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(el),
          onComplete() { clearMotionProps(el); },
          ...restExtra }
      );
    });
  };

  /* Entra desde la derecha */
  const fadeRight = (selector, extra = {}) => {
    const { x: fromX = 24, ...restExtra } = extra;
    document.querySelectorAll(selector).forEach(el => {
      if (isInView(el)) return;
      gsap.fromTo(el,
        { autoAlpha: 0, x: fromX },
        { autoAlpha: 1, x: 0, duration: 0.5, ease: 'power2.out',
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(el),
          onComplete() { clearMotionProps(el); },
          ...restExtra }
      );
    });
  };

  /* Aparece con escala */
  const scaleIn = (selector, extra = {}) => {
    document.querySelectorAll(selector).forEach(el => {
      if (isInView(el)) return;
      gsap.fromTo(el,
        { autoAlpha: 0, scale: 0.98 },
        { autoAlpha: 1, scale: 1, duration: 0.42, ease: 'power2.out',
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(el),
          onComplete() { clearMotionProps(el); },
          ...extra }
      );
    });
  };

  /* Grupo en cascada (stagger) */
  const staggerGroup = (selector, staggerTime = 0.1, extra = {}) => {
    const els = [...document.querySelectorAll(selector)];
    if (!els.length) return;
    /* Agrupar por contenedor padre para que cada grupo anime junto */
    const groups = new Map();
    els.forEach(el => {
      const key = el.parentElement;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(el);
    });
    groups.forEach(group => {
      if (isInView(group[0])) return; /* ya visible → no ocultar */
      gsap.fromTo(group,
        { autoAlpha: 0, y: 18 },
        {
          autoAlpha: 1, y: 0, duration: 0.46, ease: 'power2.out',
          stagger: staggerTime,
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(group[0]),
          onComplete: function() { clearMotionProps(group); },
          ...extra
        }
      );
    });
  };

  /* ─── Section Header ─────────────────────────────────────────────── */
  fadeUp('.sh-label');
  fadeUp('.sh-title',    { delay: 0.08 });
  fadeUp('.sh-text',     { delay: 0.16 });

  /* ─── Featured Collection ────────────────────────────────────────── */
  fadeUp('.fc-label');
  fadeUp('.fc-title',    { delay: 0.08 });
  fadeUp('.fc-subtitle', { delay: 0.14 });
  fadeUp('.fc-cta',      { delay: 0.2  });

  /* ─── Product cards (featured + collection) ──────────────────────── */
  staggerGroup('.product-card', 0.045);

  /* ─── Category cards ─────────────────────────────────────────────── */
  staggerGroup('.category-card', 0.05);
  fadeUp('.cat-section-title');

  /* ─── All Collections ────────────────────────────────────────────── */
  fadeUp('.ac-grid', { y: 30 });

  /* ─── Brand logos ────────────────────────────────────────────────── */
  fadeUp('.bl-title');
  staggerGroup('.brand-logo', 0.04, { y: 14 });

  /* ─── Promo Banner — alternando izquierda/derecha ────────────────── */
  document.querySelectorAll('.pb-panel').forEach((panel, i) => {
    const dir = i % 2 === 0 ? -22 : 22;
    if (!isInView(panel)) {
      gsap.fromTo(panel,
        { autoAlpha: 0, x: dir },
        {
          autoAlpha: 1, x: 0, duration: 0.5, ease: 'power2.out',
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: baseScrollTrigger(panel),
          onComplete() { clearMotionProps(panel); }
        }
      );
    }
    fadeUp('.pb-panel__logo');
  });

  /* ─── Solutions ──────────────────────────────────────────────────── */
  fadeUp('.sol-label');
  fadeUp('.sol-title',    { delay: 0.08 });
  fadeUp('.sol-subtitle', { delay: 0.14 });
  staggerGroup('.sol-card', 0.055);
  fadeUp('.sol-cta',      { delay: 0.1, y: 24 });

  /* ─── Testimonials ───────────────────────────────────────────────── */
  fadeUp('.tm-label');
  fadeUp('.tm-title',    { delay: 0.08 });
  staggerGroup('.tm-card', 0.06);

  /* ─── Product page ───────────────────────────────────────────────── */
  fadeLeft('.product-gallery', { x: -18 });
  fadeRight('.product-info',   { x: 18  });
  fadeUp('.product-tabs',      { delay: 0.06, y: 16 });
  staggerGroup('.related-grid .product-card', 0.045);
  fadeUp('.related-products__title');

  /* ─── Collection page ────────────────────────────────────────────── */
  fadeLeft('.collection-sidebar', { x: -16 });
  fadeUp('.collection-breadcrumb', { y: 12 });

  /* ─── Footer ─────────────────────────────────────────────────────── */
  fadeLeft('.ft-brand',    { x: -16 });
  staggerGroup('.ft-col',  0.045, { y: 14 });
  fadeUp('.ft-bottom',     { y: 12, delay: 0.06 });

  /* Recalcular triggers tras lazy-load y layout shifts */
  setTimeout(() => ScrollTrigger.refresh(), 500);
});
